import { useState, useEffect } from 'react';
import { validateToken } from '../services/tokenService';
import type { TokenErrorCode } from '../types/api.types';

interface TokenValidationState {
  isLoading:    boolean;
  isValid:      boolean;
  clientId:     string | null;
  formAccessId: string | null;
  errorCode:    TokenErrorCode | null;
}

export function useTokenValidation(token: string | null) {
  const [state, setState] = useState<TokenValidationState>({
    isLoading:    true,
    isValid:      false,
    clientId:     null,
    formAccessId: null,
    errorCode:    null,
  });

  useEffect(() => {
    if (!token) {
      setState({ isLoading: false, isValid: false, clientId: null, formAccessId: null, errorCode: 'NO_TOKEN_PROVIDED' });
      return;
    }

    // Client-side format check before making an API call
    if (token.split('.').length !== 3) {
      setState({ isLoading: false, isValid: false, clientId: null, formAccessId: null, errorCode: 'INVALID_TOKEN_FORMAT' });
      return;
    }

    let cancelled = false;

    validateToken(token).then((result) => {
      if (cancelled) return;

      if (result.success) {
        setState({
          isLoading:    false,
          isValid:      true,
          clientId:     result.data.clientId,
          formAccessId: result.data.formAccessId,
          errorCode:    null,
        });
      } else {
        setState({
          isLoading:    false,
          isValid:      false,
          clientId:     null,
          formAccessId: null,
          errorCode:    result.errorCode,
        });
      }
    });

    return () => { cancelled = true; };
  }, [token]);

  return state;
}
